import axios from 'axios';
import api from './api';
import ErrorService from './errorService';
import Swal from 'sweetalert2';

//const BASE_URL = 'https://localhost:7178/api';
const BASE_URL = 'http://192.168.20.74:8076/api';

export const audioService = {

  async getHubSpotContact(id) {
    try {
      // Usar api.get para la solicitud
      const response = await api.get(`HubSpot/contact/${id}`);

            // Mostrar mensaje de éxito usando Swal
            Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              //text: 'Se actualizó correctamente.',
              confirmButtonText: 'Aceptar',
            });
      return response.data;
    } catch (error) { 
      ErrorService.handleApiError('Error fetching HubSpot contact:', error);
      throw error;
    }
  },

  async getHubspotDealsContact(id) {
    try {
      // Usar api.get para la solicitud
      const response = await api.get(`HubSpot/contact/${id}`);
      return response.data;
    } catch (error) { 
      ErrorService.handleApiError('Error fetching HubSpot contact:', error);
      throw error;
    }
  },

  async searchTipificacionVenta(optA, telephone) {
    try {
      // Usar api.post para la solicitud
      const response = await api.post('TipificacionVenta/search', {
        optA,
        telephone,
      });
      return response.data;
    } catch (error) {
      console.error('Error searching TipificacionVenta:', error);
      throw error;
    }
  },
  
  async getAudioFiles(date, id) {
    try {
      const response = await axios.get(`${BASE_URL}/AudioFiles/GetAudioFiles`, {
        params: { date, id }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching audio files:', error);
      throw error;
    }
  },

  async searchAudio(hubspotId) {
    try {
      // Step 1: Get HubSpot contact
      const contactData = await this.getHubSpotContact(hubspotId);
      
      // Step 2: Get Deal ID
      const dealId = contactData.associations.deals.results[0]?.id;
      if (!dealId) throw new Error('No deal ID found');

      // Step 3: Search TipificacionVenta
      const tipificacionData = await this.searchTipificacionVenta(dealId, '');
      
      // Step 4: Get call ID and date
      const callId = tipificacionData[0]?.callId;
      const date = tipificacionData[0]?.date.split('T')[0]; // Get YYYY-MM-DD format

      if (!callId || !date) throw new Error('No call ID or date found');

      // Step 5: Get audio files
      const audioFiles = await this.getAudioFiles(date, callId);

      return audioFiles;
    } catch (error) {
      console.error('Error in audio search process:', error);
      throw error;
    }
  }
};